export default "__VITE_ASSET__xvm1iOIy__"